import type { MapRef } from "@vis.gl/react-maplibre";
import { useMemo, useRef, useState, type FC } from "react";
import { useRecoilValue } from "recoil";

import { MapLibreMapHost, useMapLibreLocationsAutoFit } from "@ryde/controls";
import {
  GlobalAppEventEnum,
  passengersStationsMapDataAtom,
  type ILocationInfo,
} from "@ryde/shared";

import { usePassengerMapCreatedStations } from "../hooks/use-passenger-map-created-stations";
import {
  MapButtonsControls,
  MapClickEvent,
  PassengersGridMapStyled,
  PassengersMapMarkers,
} from "./parts";

export const PassengersGridMap: FC = () => {
  const mapRef = useRef<MapRef>(null);
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  const passengersStationsMapData = useRecoilValue(
    passengersStationsMapDataAtom,
  );

  const stationsLocations = useMemo(
    () =>
      passengersStationsMapData.map(
        info => info.stationInfo,
      ) as ILocationInfo[],
    [passengersStationsMapData],
  );

  useMapLibreLocationsAutoFit({
    mapRef,
    locations: stationsLocations,
    isMapLoaded,
    resizeEvent: GlobalAppEventEnum.RESIZE_PASSENGER_MAP,
  });
  usePassengerMapCreatedStations();

  return (
    <PassengersGridMapStyled>
      <div className="map_scrollable_content">
        <MapLibreMapHost mapRef={mapRef} onLoadedChange={setIsMapLoaded}>
          <MapClickEvent />
          <MapButtonsControls />
          <PassengersMapMarkers />
        </MapLibreMapHost>
      </div>
    </PassengersGridMapStyled>
  );
};
